export default function DashboardIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.882 0H4.118C3.02584 0 1.97841 0.43386 1.20613 1.20613C0.43386 1.97841 0 3.02584 0 4.118L0 15.882C0 16.9742 0.43386 18.0216 1.20613 18.7939C1.97841 19.5661 3.02584 20 4.118 20H15.882C16.9742 20 18.0216 19.5661 18.7939 18.7939C19.5661 18.0216 20 16.9742 20 15.882V4.118C20 3.02584 19.5661 1.97841 18.7939 1.20613C18.0216 0.43386 16.9742 0 15.882 0V0ZM8.235 2.353H11.764V5.882H8.235V2.353ZM5.882 17.647H4.118C3.64989 17.647 3.20096 17.461 2.86996 17.13C2.53895 16.799 2.353 16.3501 2.353 15.882V14.118H5.882V17.647ZM11.764 17.647H8.235V14.118H11.764V17.647ZM17.646 15.882C17.646 16.3501 17.46 16.799 17.129 17.13C16.798 17.461 16.3491 17.647 15.881 17.647H14.118V14.118H17.647L17.646 15.882ZM17.646 11.764H2.353V4.118C2.353 3.64989 2.53895 3.20096 2.86996 2.86996C3.20096 2.53895 3.64989 2.353 4.118 2.353H5.882V7.059C5.882 7.21352 5.91245 7.36652 5.97161 7.50927C6.03078 7.65201 6.11749 7.7817 6.2268 7.89091C6.3361 8.00013 6.46586 8.08673 6.60866 8.14577C6.75145 8.20481 6.90448 8.23513 7.059 8.235H17.647L17.646 11.764ZM17.646 5.882H14.118V2.353H15.883C16.3511 2.353 16.8 2.53895 17.131 2.86996C17.462 3.20096 17.648 3.64989 17.648 4.118L17.646 5.882Z"
      />
    </svg>
  )
}
